import script from "./message-center-transfer.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-center-transfer.vue?vue&type=script&lang=ts&setup=true"

import "./message-center-transfer.vue?vue&type=style&index=0&id=3f5c3516&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5c3516"]])

export default __exports__